import PropTypes from "prop-types";
import typedAction from "data/util/typedAction";

const GxepActions = {
    START_LOAD: "gxep/start-load",
    LOADED: "gxep/loaded",
    LOAD_ERROR: "gxep/load-error",

    START_SAVE: "gxep/start-save",
    SAVED: "gxep/saved",
    SAVE_ERROR: "gxep/save-error",

    UPDATE_PASSWORD: typedAction("gxep/update-password", {
        key: PropTypes.string.isRequired,
        password: PropTypes.string.isRequired,
    }),

    DIALOG_CLOSED: "gxep/dialog-closed",
};

export default GxepActions;



// WEBPACK FOOTER //
// ./app/data/GxepActions.js